/**
 * 法语（fr）
 */
export default {
  orderList: {
    AllOrder: 'Tout est en ordre.',
    WaitingPayment: 'En attente de paiement',
    Pending: 'En attente de livraison',
    ToBeSighed: 'En route',
    Refunding: 'Remboursement',
    YouHave: "C'est vrai.",
    orders: 'Ordre',
    OrderID: 'No de commande',
    Customer: 'Clients',
    coupon: 'Coupons',
    TotalAmount: 'Montant total',
    PayNow: 'Payez maintenant.',
    ViewDetails: 'Voir les détails',
    CancelOrder: 'Annuler la commande',
    Delete: 'Supprimer',
    selectContent: 'Sélectionner le contenu',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    inputPlaceholder: 'Recherche par id de commande, SKU ou nom du produit',
    RequestRefund: 'Demande de remboursement',
    ConfirmReceipt: 'Accusé de réception',
    CancelReason: "Motifs d'annulation",
    Verification: 'Validation',
    RefundReason: 'Justification du remboursement',
    Remake: 'Commentaires',
    cancel: 'Annulation',
    submit: 'Décision',
    ConfirmReceiptTitle: "Êtes - vous sûr que vous avez reçu les marchandises et que la qualité est conforme à l'accord des deux parties?",
    ConfirmReceiptContent: 'Si la confirmation est correcte, cliquez sur le bouton « confirmer » ci - dessous pour compléter la confirmation de réception.',
    removeTheStore: 'Supprimer le stockage',
    CancellationReasonIsRequired: "La raison de l'annulation est requise",
    RefundReasonIsRequired: 'La raison du remboursement est requise',
    Paypal: 'Paypal',
    CreditCard: 'Carte de crédit',
    Balance: 'Équilibre',
    SelectByStatus: 'Sélectionner par statut',
    SelectByPlatform: 'Sélectionner par plate - forme',
    FulfillOrder: 'Remplir la commande',
    Store: 'Centre commercial',
    StoreOrderID: 'Numéro de commande du magasin',
    TrackingNumber: 'Numéro de la requête',
    ShippingCarrier: 'Transporteur',
    TrackingURL: 'URL de suivi',
    cancelBtn: 'Annulation',
    ok: "D'accord",
    emptyTips1: 'Votre commande est vide!',
    emptyTips2: 'Vous pouvez gérer et traiter les commandes ici',
    ChooseProduct: 'Sélectionner un produit',
    ChooseProductTips: 'Comment trouver et lister les produits',
    ConnectANewStore: 'Connexion au nouveau magasin',
    ConnectANewStoreTips: 'Comment se connecter à un nouveau magasin',
    selectAll: 'Sélectionner tout',
    orderStatusSubTip: 'Le remboursement a échoué, veuillez contacter notre équipe de soutien'
  },
  orderDetail: {
    PayNow: 'Payez maintenant.',
    ConfirmReceipt: 'Accusé de réception',
    StoreOrderID: 'Numéro de commande du magasin',
    OrderID: 'No de commande',
    Source: 'Source:',
    IncomeStatement: 'Compte de profits et pertes',
    CommodityInformation: 'Informations sur les produits',
    ShipFrom: 'De',
    ItemNo: 'Numéro du projet',
    TheDetail: 'Détails',
    Notes: 'Notes',
    OrderStatus: 'État de la commande',
    BalancePayment: 'Balance des paiements',
    PaymentTime: 'Délai de paiement',
    PaymentId: 'ID de paiement',
    ItemSubtotal: 'Total partiel',
    ShippingSubtotal: 'Livraison',
    tax: 'Fiscalité',
    PaymentAmount: 'Montant du paiement',
    ShippingAddress: 'Adresse de livraison',
    ConfirmReceiptModalTitle: `Êtes - vous sûr que vous avez reçu les marchandises et que la qualité est conforme à l'accord des deux parties?`,
    ConfirmReceiptModalContent: 'Si la confirmation est correcte, cliquez sur le bouton « confirmer » ci - dessous pour compléter la confirmation de réception.',
    Cancel: 'Annulation',
    Submit: 'Soumettre',
    removeTheStore: 'Supprimer le stockage',
    WaitingPayment: 'En attente de paiement',
    WaitingPaymentTips: `Votre commande n'a pas été payée. Cliquez sur payer maintenant pour continuer.`,
    OrderCreation: 'Création de commandes',
    Finish: 'Terminé.',
    PaymentSuccessful: 'Paiement réussi',
    IncorrectAddressInformation: 'Adresse incorrecte',
    CancelTips: 'Votre commande a été annulée avec succès',
    Pending: 'En attente de livraison',
    PendingSecondStatus: 'Normalement pas plus de 24 heures.',
    PendingTips: `Chaque produit est soumis à un contrôle de qualité rigoureux avant d'être envoyé à vos clients.`,
    Shipped: 'Chargement',
    Complete: 'Complet',
    ShippedTips1: 'Votre commande arrive!',
    PartialDelivery: 'Expédition partielle',
    ShippedTips2: `Certains de vos produits n'ont pas encore été expédiés`,
    Refunding: 'Remboursement',
    PartialRefund: 'Remboursement partiel',
    refundedTipsNew: 'Le montant total du remboursement de votre commande est de',
    RefundingSecondStatus: 'Votre remboursement sera traité dans un délai de 1 à 3 jours ouvrables',
    RefundingTips: 'Une demande de remboursement a été présentée. En attente de traitement',
    Refund: 'Remboursement',
    Refunded: 'Remboursement',
    RefundedSecondStatus: `Selon votre institution financière, l'affichage des fonds dans votre compte peut prendre jusqu'à 14 jours`,
    RefundedTips: 'La demande de remboursement a été acceptée. Le montant payé sera remboursé selon le mode de paiement initial.',
    CompleteSecondStatus: 'Fin de la transaction',
    CompleteTips: 'La commande est terminée. Merci pour votre soutien.',
    ShippingMethod: 'Mode de transport',
    MyOrder: 'Ma commande.',
    OrderInformation: 'Informations sur la commande',
    Product: 'Produits',
    PurchasePrices: "Prix d'achat",
    prices: 'Prix',
    Quantity: 'Quantité',
    Subtotal: 'Total partiel',
    Profit: 'Bénéfices',
    ConfirmReceiptTips: 'Attention au reçu.',
    trackingCode: 'Code de suivi',
    DeliveryTime: 'Délai de livraison',
    logisticsProviders: 'Fournisseurs de logistique',
    payment: 'Paiements',
    NotToDeliverGoods: 'Pas de livraison',
    LogisticsInformation: 'Informations logistiques',
    PartialDeliveryTips: "Certains produits n'ont pas encore été expédiés, nous vous informerons une fois qu'ils seront expédiés",
    PaymentInformation: 'Informations sur le paiement',
    Balance: 'balance',
    CreditCard: 'carte de crédit',
    payFail: 'Échec du paiement',
    Remaining: 'Le reste.',
    WaitingPaymentWarning: 'Les commandes en souffrance depuis plus de 120 heures seront annulées',
    OrderCancelled: 'Annulation de la commande',
    OrderConfirmed: 'Confirmation de commande',
    Shipping: 'Transport maritime',
    OrderComplete: 'Livré',
    OrderSubmitted: 'Commandes soumises',
    PleaseInput: 'Veuillez saisir',
    Note: 'Note',
    EditNote: 'Note éditée',
    Edit: 'Modifier',
    EditNoteSuccessTip: 'Notez le contenu mis à jour avec succès.',
    NoteTip: 'Voici le contenu de la note.'
  }
}
